module.exports = {
  apiModel: {
    status: 0,
    message: "",
    data: "",
    error: "",
  },
};
